import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { CommonInfoService } from '../cart-process/common-info.service';
import { YourOfferService } from '../cart-process/your-offer.service';
import { ExternalInterfacesEnum, ExternalInterfacesService } from '../external-interfaces/external-interfaces.service';
import CustomerDetailsService from '../cart-process/customer-details.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import { ICartDetails } from '../interfaces/cart-details.interface';
import { DataLayerService } from '../customer-actions/data-layer.service';
import SlotService from '../cart-process/slot.service';

declare const window: any;
declare const P4: any;

@Component({
  selector: 'page-customer-view-component',
  templateUrl: './page-customer-view.component.html',
})
export class PageCustomerViewComponent implements AfterViewInit {

  public linkNext: string;
  public offerTitle: string;

  constructor(
    public yourOffer: YourOfferService,
    public commonInfo: CommonInfoService,
    private elementRef: ElementRef,
    protected customerDetailsService: CustomerDetailsService,
    private notificationProvider: NotificationProviderService,
    private externalInterfacesService: ExternalInterfacesService,
    private dataLayerService: DataLayerService,
    private slotService: SlotService
  ) {
    this.externalInterfacesService.getData(ExternalInterfacesEnum.CART_DETAILS);

    this.notificationProvider.subscribe(NotificationProviderTypeEnum.CART_DETAILS, (cartDetails: ICartDetails) => {
      if (cartDetails) {
        this.customerDetailsService.get();

        const slots = this.slotService.getSlots();
        const summaryPrices = cartDetails.summaryPrices;

        this.dataLayerService.cartViewCheckout(summaryPrices, slots);
      }
    });

    this.notificationProvider.subscribe(NotificationProviderTypeEnum.COMMON_INFO, (commonInfo: CommonInfoService) => {
      if (commonInfo) {
        this.offerTitle = commonInfo.offerTitle;
      }
    });

    this.linkNext = this.elementRef.nativeElement.getAttribute('link-next');

    window.reloadCartDetailsInnerNg2 = this.externalInterfacesService.updateCartDetails.bind(this.externalInterfacesService);
  }

  ngAfterViewInit(): void {
    P4.modules.stickyElements.init();
  }

  public getClassNames() {
    return {
      'form-migration': this.customerDetailsService.ifCustomerDataExist && this.commonInfo.isMigrationOffer,
      'form-with-data': this.customerDetailsService.ifCustomerDataExist && !this.commonInfo.isMigrationOffer,
      'form-activation': !this.customerDetailsService.ifCustomerDataExist,
    };
  }
}
